module.exports = __webpack_public_path__ + "media/video-custom.2c44bf14.mp4";